import AbstractStrategy from './AbstractStrategy'
import Api from 'Ajax'
import {TestTemplate, TestState, Answer} from 'Models'
import {setMarkedQuestionsCountTo, incMarkedQuestionsCount, decMarkedQuestionsCount} from "@features/Bookmarks/model";
import { checkApiResponseForAuth } from '@features/_common/errorHandler';



export class QuestionRealTestStrategy extends AbstractStrategy {
    constructor() { super(); }


    //#region Static Methods
        static isLastQuestionReached()      {
            return TestState.isInResultsMode() ? Answer.isLastAnswer()
                                               : TestTemplate.isLastQuestion()
        }

        static selectedIndex()              { return TestTemplate.currentQuestionIndex(); }
        static currentQuestionsCount()      { return TestTemplate.currentQuestionsCount(); }
        static currentQuestionsDuration()   { return TestTemplate.currentQuestionsDuration(); }
        static currentQuestion()            { return TestTemplate.currentQuestion(); }
        static previousQuestion()           { return TestTemplate.previousQuestion(); }
        static currentQuestions()           { return TestTemplate.currentQuestions(); }
        static allQuestions()           { return TestTemplate.allQuestions(); }
        static allQuestionsCount()           { return TestTemplate.allQuestionsCount(); }


        static currentQuestionsSubCategories()   { return TestTemplate.currentQuestionsSubCategories() }

        static isFirstQuestionOverall()       { return TestTemplate.isFirstQuestionOverall()}
        static isFirstQuestionInBlock()       { return TestTemplate.isFirstQuestionInBlock()}

        static ignoreCurrentQuestion()        { TestTemplate.ignoreCurrentQuestion(); }
        static incSelectedIndex()             { TestTemplate.goToNextQuestion(); }
        static decSelectedIndex()             { TestTemplate.goToPreviousQuestion(); }
        static setSelectedIndexTo(index)      { TestTemplate.goToQuestionWithIndex(index); }
        static setCurrentQuestions(questionSources) { }
        static setActiveQuestions(questionSources)  { }

        static markByID(id, data)
        {
            TestTemplate.markCurrentQuestion()
            incMarkedQuestionsCount()

            return Api.postMarkQuestionWith(true, id, data)
                      .then( ({data}) => setMarkedQuestionsCountTo(data) )
                      .catch( err => {
                          TestTemplate.unmarkCurrentQuestion()
                          decMarkedQuestionsCount()
                          checkApiResponseForAuth(AbstractStrategy.ebus(), err)
                      })
        }

        static unmarkByID(id, data)
        {
            TestTemplate.unmarkCurrentQuestion()
            decMarkedQuestionsCount()

            return Api.postMarkQuestionWith(false, id, data)
                      .then( ({data}) => setMarkedQuestionsCountTo(data) )
                      .catch( err => {
                          TestTemplate.markCurrentQuestion()
                          incMarkedQuestionsCount()
                          checkApiResponseForAuth(AbstractStrategy.ebus(), err)
                      })
        }

        static resetAll()                     { TestTemplate.resetTestTemplate(); }

        static doQuestionsExistFor(mainCategoryID, subCategoryID) { }
        static loadAsCurrentQuestionsFor(mainCategoryID, subCategoryID, hasBrowserReloaded=false) { }
    //#endregion Static Methods
}


export default QuestionRealTestStrategy;
